import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
type StatItem = {
  value: number;
  suffix: string;
  label: string;
};
const stats: StatItem[] = [{
  value: 17,
  suffix: '',
  label: 'Premium Venues'
}, {
  value: 5,
  suffix: '',
  label: 'Prime Locations'
}, {
  value: 250,
  suffix: '+',
  label: 'Team Members'
}, {
  value: 12,
  suffix: '',
  label: 'Industry Awards'
}];
function AnimatedCounter({
  value,
  suffix
}: {
  value: number;
  suffix: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, {
    once: true
  });
  useEffect(() => {
    if (isInView) {
      const duration = 2000;
      const steps = 60;
      const increment = value / steps;
      let current = 0;
      const timer = setInterval(() => {
        current += increment;
        if (current >= value) {
          setCount(value);
          clearInterval(timer);
        } else {
          setCount(Math.floor(current));
        }
      }, duration / steps);
      return () => clearInterval(timer);
    }
  }, [isInView, value]);
  return <span ref={ref} className="font-display text-[56px] md:text-[72px] font-medium text-[#c9a961] leading-none" data-id="element-286">
      {count}
      {suffix}
    </span>;
}
export function Stats() {
  return <section className="bg-[#f2f2f4] py-24 md:py-32 px-6" data-id="element-287">
      <div className="max-w-7xl mx-auto" data-id="element-288">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 md:gap-16" data-id="element-289">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: index * 0.1
        }} className="text-center group" data-id="element-290">
              <div className="mb-4 relative inline-block" data-id="element-291">
                <AnimatedCounter value={stat.value} suffix={stat.suffix} data-id="element-292" />
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-0 group-hover:w-full h-[1px] bg-[#c9a961]/30 transition-all duration-700" data-id="element-293" />
              </div>
              <p className="text-[#1d1d1f] mt-2 text-[15px] uppercase tracking-widest font-medium" data-id="element-294">
                {stat.label}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}